import React from 'react'

const GeneraleContext = React.createContext()

export default GeneraleContext
